export default "__VITE_ASSET__a3cd0097__"